import React, { Fragment } from "react";
import { Scope } from "../../../../models/Scope";

export type TBodyComponentTypes = {
    scopes: Scope[];
};

const TBodyComponent = (props: TBodyComponentTypes) => {
    const { scopes } = props;
    return (
        <Fragment>
            {scopes.map(scope => (
                <React.Fragment key={scope.id}>
                    <tr>
                        <td>
                            <strong>{scope.name}</strong>
                        </td>
                        <td>
                            <strong>{scope.description}</strong>
                        </td>
                    </tr>
                </React.Fragment>
            ))}
        </Fragment>
    );
};

export default TBodyComponent;
